import { render, staticRenderFns } from "./modelWarehousing.vue?vue&type=template&id=cf8a2e38&scoped=true&"
import script from "./modelWarehousing.vue?vue&type=script&lang=js&"
export * from "./modelWarehousing.vue?vue&type=script&lang=js&"
import style0 from "./modelWarehousing.vue?vue&type=style&index=0&id=cf8a2e38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8a2e38",
  null
  
)

export default component.exports